require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var _colors = require("../styles/colors");

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Switch.tsx";
var version = _reactNative.NativeModules.PlatformConstants ? _reactNative.NativeModules.PlatformConstants.reactNativeVersion : undefined;

var Switch = function (_React$Component) {
  (0, _inherits2["default"])(Switch, _React$Component);

  function Switch() {
    (0, _classCallCheck2["default"])(this, Switch);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Switch).apply(this, arguments));
  }

  (0, _createClass2["default"])(Switch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          disabled = _this$props.disabled,
          onValueChange = _this$props.onValueChange,
          color = _this$props.color,
          theme = _this$props.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["value", "disabled", "onValueChange", "color", "theme"]);
      var checkedColor = color || theme.colors.accent;
      var onTintColor = _reactNative.Platform.OS === 'ios' ? checkedColor : disabled ? theme.dark ? (0, _color["default"])(_colors.white).alpha(0.1).rgb().string() : (0, _color["default"])(_colors.black).alpha(0.12).rgb().string() : (0, _color["default"])(checkedColor).alpha(0.5).rgb().string();
      var thumbTintColor = _reactNative.Platform.OS === 'ios' ? undefined : disabled ? theme.dark ? _colors.grey800 : _colors.grey400 : value ? checkedColor : theme.dark ? _colors.grey400 : _colors.grey50;
      var props = version && version.major === 0 && version.minor <= 56 ? {
        onTintColor: onTintColor,
        thumbTintColor: thumbTintColor
      } : {
        thumbColor: thumbTintColor,
        trackColor: {
          "true": onTintColor,
          "false": ''
        }
      };
      return React.createElement(_reactNative.Switch, (0, _extends2["default"])({
        value: value,
        disabled: disabled,
        onValueChange: disabled ? undefined : onValueChange
      }, props, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 147
        }
      }));
    }
  }]);
  return Switch;
}(React.Component);

var _default = (0, _theming.withTheme)(Switch);

exports["default"] = _default;